"use strict";

exports.__esModule = true;
exports.GridHeader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Core = require("../../Core");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a header for Grid.
 */
var GridHeader = exports.GridHeader = /*#__PURE__*/function (_Component) {
  function GridHeader() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(GridHeader, _Component);
  var _proto = GridHeader.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
      level: 4,
      ellipsize: true
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "GridHeader.headingLabel",
      defaultMessage: "Grid"
    }));
  };
  return GridHeader;
}(_react.Component);